import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ThreeCanvasComponent } from '../../../core/ctc/canvas/canvas.component';
import { LayoutService } from 'src/app/core/layout/layout.service';
import { CanvasControllerService } from '../../../core/services/canvas-controller/canvas-controller.service';
import { ActivatedRoute } from '@angular/router';
import { ProjectControllerService } from 'src/app/core/layout/layouts/workspace-layout/commons/services/project-controller/project-controller.service';
import { ThreeGraphqlService } from 'src/app/core/graphql/three/services/three-graphql.service';
import { Title } from '@angular/platform-browser';
import { Subject, take, takeUntil } from 'rxjs';
import {
  BaseModel,
  Template,
  ThreedProject,
} from 'src/app/core/layout/layouts/workspace-layout/commons/services/project-controller/project-controller';

export interface MeshInfo {
  name: string;
}

@Component({
  selector: 'app-custom',
  imports: [ThreeCanvasComponent],
  templateUrl: './custom.component.html',
  styleUrl: './custom.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomComponent implements OnInit, OnDestroy {
  public templateSlug: string | undefined;

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private title: Title,
    private route: ActivatedRoute,
    private layoutService: LayoutService,
    private threeGraphqlService: ThreeGraphqlService,
    private canvasController: CanvasControllerService,
    private projectController: ProjectControllerService,
    private cd: ChangeDetectorRef,
  ) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  ngOnInit() {
    this.getParams();
  }

  ngOnDestroy() {}
  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  public created(canvas: ThreeCanvasComponent | undefined): void {
    if (!canvas) return;
    this.canvasController.initCavas(canvas);
    this.searchUserProejectByTempleteSlug(this.templateSlug);
  }

  public isLoading(isLoading: boolean): void {
    this.layoutService.isLoading = isLoading;
  }

  public getMaterials(materials: Map<string, any>): void {
    this.canvasController.materials = materials;
    this.cd.markForCheck();
  }

  public deleteAttachStickerMeshName(e: { index: number; name: string }): void {
    this.canvasController.stateManager.updateDeleteStickerAttachMesh(e.index, e.name);
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  private getParams(): void {
    this.templateSlug = this.route.snapshot.params['templateSlug'];
    this.searchUserProejectByTempleteSlug(this.templateSlug);
  }

  private searchUserProejectByTempleteSlug(slug: string | undefined): void {
    if (!slug) return;
    this.threeGraphqlService
      .searchUserProejectByTempleteSlug(slug)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((project: ThreedProject) => {
        if (!project) this.getTemplete(slug);
        this.setProject(project);
      });
  }

  private getTemplete(slug: string): void {
    this.threeGraphqlService
      .getTemplete(slug)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((template: Template | undefined) => {
        if (!template) return;
        this.createProject(template);
      });
  }

  private createProject(template: Template): void {
    this.threeGraphqlService
      .createProeject(template.uuid)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((project: ThreedProject | undefined) => {
        if (!project) return;
        this.setProject(project);
      });
  }

  private setProject(project: ThreedProject): void {
    if (!project) return;
    this.setTitle(project);
    if (!project.baseModels) return;
    this.threeGraphqlService
      .getBaseModel(project.baseModels[0].uuid)
      .pipe(take(1))
      .subscribe((baseModel) => {
        if (!project.baseModels || !baseModel) return;
        project.baseModels[0] = baseModel;
        this.projectController.initProject(project);
        this.addBaseModel(baseModel);
        this.cd.markForCheck();
      });
  }

  private setTitle(project: ThreedProject): void {
    this.title.setTitle(`${project.title} by ${this.route.snapshot.params['user'] || 'Scattre'}`);
  }

  private addBaseModel(baseModel: BaseModel): void {
    if (!baseModel) return;
    this.canvasController.addModel(baseModel, true).then((object) => {
      if (!object) return;
      this.canvasController.getObjectRatio(object, baseModel?.width || 0),
        (this.layoutService.isFullLoading = false);
    });
  }
}
